import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { Route } from '@americanexpress/one-app-router';
import Error404Page from './components/Common/Error404Page';
import ErrorMessage from './components/Common/ErrorMessage';
import SuccessMessage from './components/Common/SuccessMessage';
import Register from './components/Register/Register';
import RsvpErrorPage from './components/Register/Registration/RsvpErrorPage';

const childRoutes = () => [
  <Route key="register-path" path="register" component={Register} />,
  <Route key="rsvp-error-path" path="rsvp-error" component={RsvpErrorPage} />,
  <ModuleRoute
    key="axp-secure-file-express-portal"
    path="/"
    moduleName="axp-secure-file-express-portal"
    hasChildRoutes={true}
  />,
  <Route key="error-paths" path="error" component={ErrorMessage} />,
  <Route key="success-paths" path="success" component={SuccessMessage} />,
  <Route key="error404-paths" path="*" component={Error404Page} />,
];

export default childRoutes;
